const filters = {
    state: {
        filterState: false,
    },

    actions: {
        setFilters({ commit }, newState) {
            commit("setFilters", newState);
        },
    },

    mutations: {
        setFilters: (state, payload) => (state.filterState = payload),
    },

    getters: {
        showMobileFilters: (state) => state.filterState,
    },
};

export default filters;
